module.exports = __webpack_public_path__ + "static/media/bg.69a87b73.jpg";